export class CounterModule {
  initialize() {
    this.counters = document.querySelectorAll(".counter");
    this.counters.forEach((counter) => new Counter(counter).start());
  }
}

class Counter {
  constructor(counterElement) {
    this.counterElement = counterElement;
  }

  get counterNumberElement() {
    return this.counterElement.querySelector(".counter-number");
  }

  get counterType() {
    return this.counterNumberElement.dataset.counterType;
  }

  get precision() {
    return this.counterNumberElement.dataset.precision.split("_");
  }

  get maximumNumber() {
    return parseInt(this.counterNumberElement.dataset.countTo, 10);
  }

  get targetDate() {
    return new Date(this.counterNumberElement.dataset.countTo);
  }

  start() {
    const Timer = this.counterType === "date" ? DateCounter : NumberCounter;
    this.timer = new Timer(this);
    this.timer.start();
  }
}

class BaseCounter {
  constructor(counter) {
    this.counter = counter;
  }

  adjustFontSize(element, value) {
    const valueLength = String(value).length;
    let fontSize = 2;
    if (valueLength === 3) {
      fontSize = 1.7;
    } else if (valueLength === 4) {
      fontSize = 1.4;
    } else if (valueLength === 5) {
      fontSize = 1.1;
    } else if (valueLength > 5) {
      fontSize = 0.9;
    }
    // For both single element and flip elements:
    if (element.querySelector(".counter-flip")) {
      const flipElement = element.querySelector(".counter-flip");
      const currentElement = flipElement.querySelector(".counter-flip__current");
      const nextElement = flipElement.querySelector(".counter-flip__next");
      currentElement.style.fontSize = `${fontSize}rem`;
      nextElement.style.fontSize = `${fontSize}rem`;
    } else {
      element.style.fontSize = `${fontSize}rem`;
    }
  }

  updateFlip(element, value) {
    const flipElement = element.querySelector(".counter-flip");
    const currentElement = flipElement.querySelector(".counter-flip__current");
    const nextElement = flipElement.querySelector(".counter-flip__next");
    const currentValue = parseInt(currentElement.textContent, 10);

    if (currentValue !== value) {
      nextElement.textContent = value;

      currentElement.classList.add("counter-flip__current--flip");
      nextElement.classList.add("counter-flip__next--flip");

      setTimeout(() => {
        currentElement.textContent = value;
        currentElement.classList.remove("counter-flip__current--flip");
        nextElement.classList.remove("counter-flip__next--flip");
      }, 400);
    }
  }
}

class DateCounter extends BaseCounter {
  calculateTimeUnits(remainingSeconds) {
    const units = [
      { unit: "days", value: Math.floor(remainingSeconds / (60 * 60 * 24)) },
      { unit: "hours", value: Math.floor((remainingSeconds / (60 * 60)) % 24) },
      { unit: "minutes", value: Math.floor((remainingSeconds / 60) % 60) },
      { unit: "seconds", value: remainingSeconds % 60 },
    ];
    return units.filter((unit) => this.counter.precision.includes(unit.unit));
  }

  updateDisplay(units) {
    const counterNumberElement = this.counter.counterNumberElement;
    units.forEach((unit) => {
      const element = counterNumberElement.querySelector(
        `.counter-time[data-unit=${unit.unit}]`
      );
      if (!element) return;
      
      this.adjustFontSize(element, unit.value);
      this.updateFlip(element, unit.value);
    });
  }

  start() {
    const update = () => {
      const remainingSeconds = Math.max(
        Math.floor((this.counter.targetDate - new Date()) / 1000),
        0
      );
      const timeUnits = this.calculateTimeUnits(remainingSeconds);
      this.updateDisplay(timeUnits);

      if (remainingSeconds > 0) {
        setTimeout(update, 1000);
      }
    };
    update();
  }
}

class NumberCounter extends BaseCounter {
  constructor(counter) {
    super(counter);
    // Duration for the animation in milliseconds.
    this.duration = 1500;
  }

  set counterNumber(value) {
    const counterNumberElement = this.counter.counterNumberElement;
    const formattedValue = Math.max(0, Math.ceil(value));
    counterNumberElement.textContent = formattedValue;
    this.adjustFontSize(counterNumberElement, formattedValue);
  }

  start() {
    const step = this.counter.maximumNumber / this.duration;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      if (elapsed < this.duration) {
        this.counterNumber = Math.min(step * elapsed, this.counter.maximumNumber);
        requestAnimationFrame(animate);
      } else {
        this.counterNumber = this.counter.maximumNumber;
      }
    };

    requestAnimationFrame(animate);
  }
}